import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Space } from 'antd';
import Button from 'components/Button';
import InputText from 'components/InputText';
import DateInterval from 'components/InputDateInterval';
import * as Style from 'components/Style';
import * as S from './styles';
import { fetchGetTodosStatus } from 'store/fetchActions/fetchInputForm';
import { changeInputFilter } from 'utils/formUtils';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import { isValidForm } from './FilterForm';
import InputSelect from 'components/InputSelect';
import { duckCleanRelatorioTodosRequerimentos } from 'store/ducks/relatorios';

export default function Filtro({ dadosGrid, filtroInicial, salvarFiltro, handlePesquisar, funcExportarRelatorio }) {
  const dispatch = useDispatch();

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const listaStatus = useSelector(state => state.status.todosStatus);

  const [isClearDataRequerimento, setIsClearDataRequerimento] = useState(false);
  const [isClearDataEncerramento, setIsClearDataEncerramento] = useState(false);
  const [disabledPesquisar, setDisabledPesquisar] = useState(true);
  const [disabledExportar, setDisabledExportar] = useState(true);

  const { control, handleSubmit, setValue, getValues, formState } = useForm({
    defaultValues: filtroInicial,
  });

  React.useEffect(() => {
    if (dadosGrid?.length === 0) {
      setDisabledExportar(true);
    }
  }, [dadosGrid]);

  React.useEffect(() => {
    if (unitaryTests) return;
    dispatch(fetchGetTodosStatus(listaStatus));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, unitaryTests]);

  const handleChange = e => {
    changeInputFilter(e, setValue);
    if (isValidForm(getValues())) {
      setDisabledPesquisar(false);
    } else {
      setDisabledPesquisar(true);
    }
  };

  const onSubmit = data => {
    setDisabledExportar(false);
    handlePesquisar(data);
  };

  const limparFiltro = () => {
    dispatch(duckCleanRelatorioTodosRequerimentos());
    setDisabledPesquisar(true);
    setDisabledExportar(true);
    setIsClearDataEncerramento(true);
    setIsClearDataRequerimento(true);
    setValue('dataAbertura', '');
    setValue('dataEncerramento', '');
    setValue('protocolo', '');
    setValue('statusId', '');
    salvarFiltro({});
  };

  return (
    <form>
      <Style.GlobalCard>
        <Row>
          <Col xs={24} sm={24} md={8} lg={8} xl={3}>
            <DateInterval
              label="Data de Abertura *"
              name="dataAbertura"
              control={control}
              onChange={handleChange}
              isClear={isClearDataRequerimento}
              openChange={() => setIsClearDataRequerimento(false)}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={3}>
            <DateInterval
              label="Data do Encerramento"
              name="dataEncerramento"
              control={control}
              onChange={handleChange}
              isClear={isClearDataEncerramento}
              openChange={() => setIsClearDataEncerramento(false)}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={3}>
            <InputText
              label="Protocolo"
              name="protocolo"
              placeholder={'Protocolo'}
              control={control}
              onChange={handleChange}
              maxLength={14}
              errors={formState.errors}
            />
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={5}>
            <InputSelect
              label="Status"
              name="statusId"
              placeholder={'Status'}
              control={control}
              options={montarDadosInputSelect(listaStatus, 'id', 'descricao')}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={5}>
            <S.ContainButton>
              <Space>
                <Button text={'Pesquisar'} clickAction={handleSubmit(onSubmit)} disabled={disabledPesquisar} />
                <Button text={'Limpar Filtro'} clickAction={() => limparFiltro()} disabled={disabledPesquisar} />
                <Button
                  text={'Exportar Relatório'}
                  clickAction={() => funcExportarRelatorio()}
                  disabled={disabledExportar}
                />
              </Space>
            </S.ContainButton>
          </Col>
        </Row>
      </Style.GlobalCard>
    </form>
  );
}
